<script>
    import { layoutOption, mode , queryStr, apiConfig, memberInfo, cipherText } from '../store/inapp-store'
    import { inappFetch } from '../store/inapp-auth'
    import { Modal, Loader } from '../components';
    import { getWalletStatusV3 } from '../store/openpoint'
    import { onMount } from 'svelte';

    $layoutOption.showBanner = false
    $layoutOption.showCarousel = false

    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    const payType = urlParams.get('payType')
    const isIcpA2A = payType === 'icpo_a2a'

    $:console.log('payType=', payType)

    let loader = { content : '錢包狀態確認中...' };
    let isBlock = true;

    let walletResult = {
        opw: '',
        icashpay: ''
    }

    let modal = {
        title : '登記借杯',
        message : '取得錢包狀態失敗，請稍候再試',
        type: 'alert'
    }

    let isOpen = false

    onMount(() =>{
        if (isIcpA2A) {
            checkIcpLoginStatus()
            return
        }

        try {
            // 取得錢包狀態V3 (配合中信收單行之功能，2025/12月版 (5.66.0) 開始提供，主要是回覆新OPEN錢包、愛金卡支付工具狀態)
            getWalletStatusV3()
        } catch(e) {
            if($mode === 'app') {
                modal.message  = '取得錢包狀態失敗，請稍候再試'
                isBlock = false
                isOpen = true
            }
        }

        let timer = setInterval(function(){

            // 根據所選payType判斷該種支付工具是否可用
            // 是否有登入icash Pay帳號
            var isIcashpay = document.getElementById('isIcashpay').value;
            console.log('isIcashpay', isIcashpay)

            // 是否有「新OPEN 錢包」信用卡交易工具
            var isOpw = document.getElementById('isOpw').value;
            console.log('isOpw', isOpw)

            if(isIcashpay !== '' && isOpw !== '') {
                walletResult.icashpay = isIcashpay
                walletResult.opw = isOpw

                clearInterval(timer)

                // 根據支付類型檢查對應的錢包狀態
                if (payType === 'online' || payType === 'newopw') {
                    if (walletResult.opw === 'Y') {
                        nextStep()
                        return false
                    } else {
                        showErrorModal('請至會員中心 → 支付管理綁定OPEN錢包的信用卡')
                    }
                } else if (payType === 'icpo') {
                    if (walletResult.icashpay === 'Y') {
                        nextStep()
                        return false
                    } else {
                        showErrorModal('請至會員中心 → 支付管理登入icash Pay帳號')
                    }
                }
            }

        },1000)

        if($mode !== 'app')  {
            setTimeout(function(){
                document.getElementById('isIcashpay').value = 'Y'
                document.getElementById('isOpw').value = 'Y'
            },2000)
        }

        return () => clearInterval(timer)
    })

    async function checkIcpLoginStatus() {
        try {
            const response = await inappFetch(`${$apiConfig.apiUrl}/icp/login-status?code=${$apiConfig.apiKey}&gid=${$memberInfo.gid}&ct=${encodeURIComponent($cipherText)}`, {
                method: 'GET'
            })
            const data = await response.json()
            console.log('icp login status', data)

            if (data.info?.isLoggedIn) {
                nextStep()
                return
            }

            showErrorModal('請先登入 icash Pay')
        } catch (e) {
            console.log(e)
            showErrorModal('確認 icash Pay 登入狀態失敗')
        }
    }

    function showErrorModal(message) {
        modal.message = message
        isBlock = false
        isOpen = true
    }

    function nextStep() {
        location.href = `/op-payment${(payType === 'icpo' || payType === 'icpo_a2a') ? '-icp' : payType === 'newopw' ? '-opw' : ''}`
    }

</script>

<input type="hidden" id="isOpw" >
<input type="hidden" id="isIcashpay" >
<input type="hidden" id="opwcardIssuerList" >

<Loader {loader} {isBlock}></Loader>
<Modal {modal} {isOpen} on:closeModal={e => location.href = `/home${$queryStr}`}></Modal>
